export default __webpack_public_path__ + "static/media/bpt-xpdeli2.78154ad7.png";